import history from "../../routes/history";
import * as AUTH_UTIL from "../../common/constants/authUtil";
import * as MSG_CONSTANT from "../../common/constants/messages";
import { Base64 } from 'js-base64';
import * as CONSTANTS from "../../common/constants/constants";
import { BaseUrl } from "../../common/constants/envConfig";
const BASE_URL = BaseUrl();

// authLogin - on successful login, return response
// on login fail show proper error-text
export const authLogin = (loginObj, enqueueSnackbar) => (dispatch) => {
  let details = {
    email: loginObj.username,
    password: loginObj.password,
  };
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  // API call to fetch the api key
  return fetch(BASE_URL + `${CONSTANTS.URLS.LOGIN}`, {
    method: AUTH_UTIL.HEADER_METHOD.POST,
    headers: AUTH_UTIL.HEADER_CONTENT_TYPE,
    body: formBody,
  })
    .then((response) => response.json())
    .then((result = {}) => {
      if (result.apiKey) {
        AUTH_UTIL.setToken(result.apiKey);
        AUTH_UTIL.setPassword(Base64.encode(loginObj.password));
        history.push(CONSTANTS.APP_ROUTS.ADD_PATIENT);
        return result;
      } else {
        enqueueSnackbar(MSG_CONSTANT.MESSAGES.INVALID_CRED, {
          variant: MSG_CONSTANT.MESSAGES.TYPE.error,
          autoHideDuration: MSG_CONSTANT.TOASTR_TIMER.T5_SEC,
        });
      }
    })
    .catch((err) => {
      enqueueSnackbar(
        `${MSG_CONSTANT.MESSAGES.SOMETHING_WENT_WRONG} with
         ${MSG_CONSTANT.MESSAGES.AUTHENTICATION}`,
        {
          variant: MSG_CONSTANT.MESSAGES.TYPE.error,
          autoHideDuration: MSG_CONSTANT.TOASTR_TIMER.T5_SEC
        }
      );
    });
};

// Logout from app, clear all state
export const logout = () => {
  // clear all global state (Redux)
  AUTH_UTIL.clearToken();
  history.push(CONSTANTS.APP_ROUTS.LOGIN);
};
